import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-screen" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "flex justify-center" }

import { onMounted, ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";
import store from "@/store";

import { toast } from "@/common/utils/toast";
import { maskDateBR } from "@/common/utils/mask";

import {
  userAccountByMember,
  userProfile,
  userProfileParch,
} from "@/common/api/rest/user";

import {
  fileAvatarCreate,
  fileAvatarUpdate,
  fileAvatarDelete,
} from "@/common/api/rest/file/avatar";

import { PanelTheme } from "@/common/themes";

import {
  baseAvatar,
  baseConfirm,
  baseInput,
  baseSelect,
  baseTextarea,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, tm } = useI18n();

const DEFAULT_PAYLOAD = {
  name: "",
  social_name: "",
  avatar: null,
  email: "",
  gender: null,
  birthdate: "",
  registration_number: "",
  description: "",
};

const profile = ref({ ...DEFAULT_PAYLOAD });
const account = ref<any>(null);

const showAvatarDel = ref(false);

const member = computed(() => store.getters.user);

const genderOptions = computed(() => [
  {
    option: "Masculino",
    value: "MALE",
  },
  {
    option: "Feminino",
    value: "FEMALE",
  },
  {
    option: "Outro",
    value: "OTHER",
  },
]);

function fecthAccount() {
  userAccountByMember(member.value?.member_id)
    .then((response) => {
      const { success, data, message } = response;
      if (success) {
        account.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function fetchProfile() {
  if (!member.value) return;

  userProfile()
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        const {
          avatar,
          birthdate,
          name,
          social_name,
          registration_number,
          gender,
          description,
        } = data;

        profile.value = {
          avatar,
          birthdate,
          name,
          gender,
          social_name,
          description,
          registration_number,
          email: store.getters.user.email,
        };

        store.commit("SET_PROFILE", data);
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update(field: string) {
  if (!member.value) return;

  let payload = { [field]: profile.value[field] };

  userProfileParch(payload)
    .then((response) => {
      const { success, message } = response;
      if (success) {
        fetchProfile();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function addAvatar(file: string) {
  if (!member.value || !account.value) return;

  fileAvatarCreate(account.value.account_id, {
    owner_id: member.value.member_id,
    type: "USER",
    file,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchProfile();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function updateAvatar(file: string) {
  if (!profile.value?.avatar || !account.value) return;

  fileAvatarUpdate(account.value.account_id, profile.value.avatar.avatar_id, {
    file,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchProfile();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeAvatar(avatar: string) {
  if (profile.value.avatar) {
    updateAvatar(avatar);
  } else {
    addAvatar(avatar);
  }
}

function delAvatar() {
  showAvatarDel.value = true;
}

function delAvatarConfirm() {
  if (!profile.value?.avatar || !account.value) return;

  fileAvatarDelete(account.value.account_id, profile.value.avatar.avatar_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchProfile();
        showAvatarDel.value = false;
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

const debounceUpdate = debounce(update, 1000);

onMounted(() => {
  fetchProfile();
  fecthAccount();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(PanelTheme), null, {
      default: _withCtx(() => [
        _createElementVNode("article", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(baseAvatar), {
                  position: "center",
                  "is-edit": true,
                  "show-image": true,
                  url: profile.value.avatar?.large,
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (changeAvatar($event))),
                  onDel: _cache[1] || (_cache[1] = ($event: any) => (delAvatar()))
                }, null, 8, ["url"])
              ]),
              _createVNode(_unref(baseInput), {
                modelValue: profile.value.name,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((profile.value.name) = $event)),
                  _cache[3] || (_cache[3] = ($event: any) => (_unref(debounceUpdate)('name')))
                ],
                value: profile.value.name,
                placeholder: _unref(t)('common.placeholders.name'),
                required: true,
                "max-length": 50
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " * ", 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "placeholder"]),
              _createVNode(_unref(baseInput), {
                modelValue: profile.value.email,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((profile.value.email) = $event)),
                value: profile.value.email,
                placeholder: _unref(t)('common.placeholders.email'),
                disabled: true,
                required: true,
                "max-length": 50
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.email")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "placeholder"]),
              _createVNode(_unref(baseInput), {
                modelValue: profile.value.registration_number,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((profile.value.registration_number) = $event)),
                  _cache[6] || (_cache[6] = ($event: any) => (_unref(debounceUpdate)('registration_number')))
                ],
                value: profile.value.registration_number,
                required: true,
                "max-length": 75
              }, {
                label: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode(" Matrícula ", -1)
                ]))]),
                _: 1
              }, 8, ["modelValue", "value"]),
              _createVNode(_unref(baseInput), {
                modelValue: profile.value.birthdate,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((profile.value.birthdate) = $event)),
                  _cache[8] || (_cache[8] = ($event: any) => (_unref(debounceUpdate)('birthdate')))
                ],
                value: profile.value.birthdate,
                placeholder: _unref(t)('common.placeholders.birthdate'),
                required: true,
                "max-length": 50,
                mask: _unref(maskDateBR)
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.birthdate")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "placeholder", "mask"]),
              _createVNode(_unref(baseSelect), {
                modelValue: profile.value.gender,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((profile.value.gender) = $event)),
                value: profile.value.gender,
                options: genderOptions.value,
                "is-empty": false,
                onChange: _cache[10] || (_cache[10] = ($event: any) => (update('gender')))
              }, {
                label: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode(" Sexo ", -1)
                ]))]),
                _: 1
              }, 8, ["modelValue", "value", "options"]),
              _createVNode(_unref(baseTextarea), {
                modelValue: profile.value.description,
                "onUpdate:modelValue": [
                  _cache[11] || (_cache[11] = ($event: any) => ((profile.value.description) = $event)),
                  _cache[12] || (_cache[12] = ($event: any) => (_unref(debounceUpdate)('description')))
                ],
                value: profile.value.description,
                placeholder: _unref(t)('common.placeholders.describe'),
                rows: 5
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "placeholder"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(baseConfirm), {
      show: showAvatarDel.value,
      title: _unref(t)('common.modals.titles.remove_avatar').toUpperCase(),
      message: _unref(t)('common.modals.messages.remove_avatar'),
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (showAvatarDel.value = false)),
      onConfirm: _cache[14] || (_cache[14] = ($event: any) => (delAvatarConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})